export { default } from './PlayerTable';
